import { render, staticRenderFns } from "./passwordFormat.vue?vue&type=template&id=52b64cd7&scoped=true"
import script from "./passwordFormat.vue?vue&type=script&lang=js"
export * from "./passwordFormat.vue?vue&type=script&lang=js"
import style0 from "./passwordFormat.vue?vue&type=style&index=0&id=52b64cd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b64cd7",
  null
  
)

export default component.exports